/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://pt16n13p5i.execute-api.us-east-2.amazonaws.com/hyattkhob",
            "region": "us-east-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://zulo6mvkebb43mivhx7lwokz3y.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-mksuadvue5bzvklvsjphdq72je",
    "aws_cognito_identity_pool_id": "us-east-2:8dcdb7c2-b1fc-4b55-885d-41427d20fbf9",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_cd3NuY99g",
    "aws_user_pools_web_client_id": "6tdpqb95c37isuh82l03cmjcd7",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
